module.exports = __webpack_public_path__ + "img/sistemas-bombeo (2).e42e427d.jpg";